import { FLAG_RC_ANALYTICS_IFRAME } from '@app/feature-flags/flags';
import { useFlags } from '@app/hooks/use-flags';
import React from 'react';

import { FLAG_ENABLE_CH_DASHBOARD_ANALYTICS } from '../../constants';
import { useAnalyticsContext } from '../../providers/analytics-provider';
import { Admin } from '../admin';
import { Events } from '../events/events';
import { Overview } from '../overview/overview';
import { Registrants } from '../registrants/registrants';
import { Series } from '../series/series';
import { Videos } from '../videos/videos';
import { getAnalyticsTabs, resolveActiveTab } from './get-analytics-tabs';

export const TabContent = () => {
  const {
    state: { selectedTab },
  } = useAnalyticsContext();
  const flags = useFlags();
  const enableCHDashboardAnalytics =
    flags?.[FLAG_ENABLE_CH_DASHBOARD_ANALYTICS];
  const showAdminPanel = flags?.[FLAG_RC_ANALYTICS_IFRAME];

  const content: React.ReactNode[] = [
    <Overview key="overview" />,
    <Events key="events" />,
    <Series key="series" />,
    <Registrants key="registrants" />,
  ];

  if (enableCHDashboardAnalytics) {
    content.push(<Videos key="videos" />);
  }

  if (showAdminPanel) {
    content.push(<Admin key="admin" />);
  }

  const tabs = getAnalyticsTabs({ enableCHDashboardAnalytics, showAdminPanel });
  const { activeIndex } = resolveActiveTab(tabs, selectedTab);

  return <div className="mt-6">{content[activeIndex]}</div>;
};
